module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/OEBPS/pppsorrowend0006#toc"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "ep"
  }, [_vm._v("“Once to die is better than length of days"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("in sorrow without end.”")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("Aeschylus, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Prometheus Bound")]), _vm._v(", 1.750-1"), _c('br', {
    staticClass: "calibre1"
  }), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("From Chambers "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Dictionary of Quotations,")]), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("translator unknown")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cceff10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-sorrowend0004.vue
// module id = 69
// module chunks = 0